import { useDirectusItems } from "#imports";
import { useRuntimeConfig } from "#app";
import { ref, watch } from "vue";
import { useLiveEditorStore } from "../stores/useLiveEditorStore.mjs";
import { useMode } from "./useMode.mjs";
export const useFetchLiveEditorValues = async (edit, user) => {
  const { getItems } = useDirectusItems();
  const { current_lang_page } = useMode();
  const liveEditorValues = ref([]);
  const is_auto_fetch = useRuntimeConfig().public.live_editor?.autoFetch;
  const fetchDataLive = async () => {
    let fields = edit ? ["*"] : ["option_key", "option_value"];
    liveEditorValues.value = await getItems({
      collection: "live_editor",
      params: {
        limit: -1,
        fields,
        filter: {
          language: current_lang_page.value
        }
      }
    }).then((res) => {
      useLiveEditorStore().setLiveEditor({
        user,
        is_edit: edit,
        data_live_editor: res
      });
      return res;
    }).catch((e) => {
      console.warn("[LiveEditor] Cant read or not existed!", e);
      return [];
    });
  };
  watch(
    () => current_lang_page.value,
    async (val, old) => {
      if (val == old)
        return;
      if (!is_auto_fetch)
        return;
      await fetchDataLive();
    }
  );
  if (is_auto_fetch) {
    await fetchDataLive();
  }
  return { fetchDataLive, liveEditorValues };
};
